import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

import { CircularContainer, StyledButton } from './button.styled';
import { TButtonProps } from './button.types';

export const Button: React.FC<TButtonProps> = ({
  variant,
  size,
  clicked,
  icon,
  tooltip,
  tooltipProps,
  disabled,
  loading,
  children,
  noWrap,
  ...props
}) => {
  const getButtonIcon = () => {
    if (!icon) {
      return null;
    }
    return loading ? <CircularProgress /> : icon;
  };

  const getButtonLabel = () => {
    if (loading && !icon) {
      return (
        <CircularContainer>
          <CircularProgress />
          <span className="hidden-label">{children}</span>
        </CircularContainer>
      );
    }
    return children;
  };

  return (
    <Tooltip
      title={tooltip ?? ''}
      wrapper={props.fullWidth ? 'fullWidth' : 'default'}
      {...tooltipProps}
    >
      <StyledButton
        $variant={variant}
        $size={size}
        $clicked={clicked}
        $noWrap={noWrap}
        disabled={disabled || loading}
        {...props}
      >
        {getButtonIcon()}
        {getButtonLabel()}
      </StyledButton>
    </Tooltip>
  );
};
